/** Labels for knowledge_surface.surface_kind (shared with Add knowledge wizard). */
export const SURFACE_KIND_LABELS = {
  architecture_principles: "Architecture principles",
  design_patterns: "Design patterns",
  sop_runbook: "SOPs & runbooks",
  security_standards: "Security standards",
  knowledge_article: "Knowledge articles",
  domain_knowledge_base: "General / other",
  policy_library: "Policy library",
  entity_surface: "Entity surface",
};

export function surfaceKindLabel(kind) {
  const key = String(kind || "").trim().toLowerCase();
  return SURFACE_KIND_LABELS[key] || "Reference category";
}

export function formatSourceKind(kind) {
  const k = String(kind || "").trim().toLowerCase();
  if (k === "upload") return "Uploaded file";
  if (k === "paste") return "Pasted text";
  if (k === "connector_import") return "Connector import";
  if (k === "enrichment_session") return "Enrichment session";
  return k ? k.replace(/_/g, " ") : "Source";
}

export function formatWhen(value) {
  if (!value) return "";
  try {
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return "";
    return d.toLocaleString(undefined, {
      dateStyle: "medium",
      timeStyle: "short",
    });
  } catch {
    return "";
  }
}
